import React, { useEffect, useState } from 'react'
import { defPath, fetchPath } from '../config/defPath'
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { useAlert } from '../hooks/useState'
import Alert from '../components/layout/Alert'

const Tapa = () => {
    const [code, setCode] = useState('');


    useEffect(() => {
        handleCodeTapa()
    }, [])



    const handleCodeTapa = async () => {
        const URL = `${fetchPath}/aguila/loyalty/tapacode`
        try {
            const res = await fetch(URL, { method: 'GET' })
            const code = await res.json()

            if (code) {
                setCode(code);
            }

        } catch (error) {
            console.warn(error)
            setCode('')
        }
    }
    const { setAlert, closeAlert } = useAlert(state => state)

    const handleCopyToClipboard = () => {

        var copyText = document.getElementById("codeCopy") as HTMLInputElement;

        // Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.value);
        
        setAlert({
            title: `${copyText.value}`,
            desc: `Copiado al portapapeles`,
            type: `great`,
            time: 3000
        })
        setTimeout(closeAlert, 3000)

        // if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        //     navigator.clipboard.writeText(code).then(() => {
        //         setAlert({
        //             title: `${code}`,
        //             desc: `Copiado al portapapeles`,
        //             type: `great`,
        //             time: 3000
        //           })
        //         setTimeout(closeAlert, 3000)
        //     })
        // }
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Card',
            'event_label':  'Copy code - Tapa' ,
            'interaction':'true',
            'component_name': 'Modo_Carrera_Codes',
            'element_text': 'Copiar',
        });
        // return Promise.reject("The Clipboard API is not available.");
    };
    function handleClick(event: any) {
        var btnRedimir = document.querySelector('.btn-redimir-tapa') as HTMLElement
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Button',
          'event_label':  'Redeem now - Tapa' ,
          'interaction':'true',
          'component_name': 'Modo_Carrera_Codes',
          'element_text': btnRedimir?.innerText,
        });
        
    }

    function handleClickComprarTada(event: any) {
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Button',
          'event_label':  'Get Aguila - Error' ,
          'interaction':'true',
          'component_name': 'Modo_Carrera_Codes',
          'element_text': 'Comprar Aguila en TaDa',
        });
    }

    function handleClickEscaneaTapa(event: any) {
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Button',
          'event_label':  'Scan again - Error' ,
          'interaction':'true',
          'component_name': 'Modo_Carrera_Codes',
          'element_text': 'Escanear de nuevo',
        });
    }

    return (
        <>
            <NewHeader />
            <Modal />

            <div className='tadaSection'>
                <section className="tadaSection__body">

                    {code.length ?
                        <div className="tadaSection__top">
                            <h1 className='titleSection ar__title'>¡que crack!</h1>
                            <p className='textSection mt-30'>
                                Con este código podrás seguir jugando en la página de Aguila, para acumular más puntos y ganar premios <br /> ¡Buena suerte!
                            </p>
                            <div className={`boxCodeTapa`}>
                                <p className={'boxCode--tapa'}>{code}</p>
                                <input type="text" id='codeCopy' defaultValue={code} style={{display: 'none'}} />
                                <button
                                    className={`ar__btn-primary ar__btn-copy`}
                                    onClick={handleCopyToClipboard}
                                >
                                    copiar
                                </button>
                            </div>
                        </div> :
                        <div className="tadaSection__top">
                            <h1 className='titleSection ar__title'>Ha <br /> ocurrido <br /> un error</h1>
                            <p className='textSection p-50'>por favor, Intenta de nuevo</p>
                            <a className="ar__btn-primary" onClick={handleClickEscaneaTapa}>escanear de nuevo</a>
                        </div>
                    }

                    <div className="tadaSection__bottom">
                        {code ?
                            <a onClick={handleClick} className="ar__btn-primary btn-redimir-tapa" href='/estadio-aguila/codigo-tada'>Redimir ahora</a> :
                            <a href='https://onelink.tadadelivery.com.co/6iLg/cwgnbeud' onClick={handleClickComprarTada} target='_blank' className="btnFull">
                                <p className='btnFull__body'>
                                    Comprar
                                    <img src={`${defPath}/assets/images/icons/logo_aguila.svg`} alt="logo aguila" />
                                    En
                                    <img src={`${defPath}/assets/images/icons/logo_tada_blue.svg`} alt="logo tada" />
                                </p>
                            </a>
                            
                        }
                        {code ?
                            <a href='https://www.cervezaaguila.com/node/966' target="_blank">
                                <p className='textBtn'>* Aplican términos y condiciones</p>
                            </a>
                            :
                            <p className='textBtn'>Recuerda que todas nuestras compras te dan puntos</p>
                        }
                    </div>
                </section>
            </div>
        </>
    )
}

export default Tapa

